module.exports = __webpack_public_path__ + "img/service-banner6.d6a5c03e.png";